import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAccountSetting } from '../../store/auth/auth.actions';
import { showFeedback } from '../../store/ui/ui.actions';
import { Button, Input, Title } from '../shared';
import { selectAccount, selectIsAdmin } from '../../store/auth/auth.selector';
import { translate } from '../../lib/lang.helper';
import { selectLang } from '../../store/ui/ui.selector';

const LineAssessExpireDaysInput = () => {
  const dispatch = useDispatch<any>();
  const account = useSelector(selectAccount);
  const isAdmin = useSelector(selectIsAdmin);
  const lang = useSelector(selectLang);

  const [val, setVal] = useState('');
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setVal((account?.line_assess_expire_days ?? 90).toString());
  }, [account?.line_assess_expire_days]);

  const handleInput = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setVal(event.target.value);
  };

  const submitVal = async () => {
    const line_assess_expire_days = parseInt(val);
    if (isNaN(line_assess_expire_days) || line_assess_expire_days < 0) return;
    setDisabled(true);
    const res = await dispatch(
      updateAccountSetting({ line_assess_expire_days }),
    );
    setDisabled(false);
    if (res !== true) {
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'error',
          message: translate(lang, res?.data?.message ?? 'Server error'),
        }),
      );
    }
  };

  return (
    <div className='mb-32'>
      <div className='d-flex mb-16 mt-27 align-center justify-between'>
        <Title size={6} color='black-3' align='default' fontWeight={500}>
          {translate(lang, '_line_assess_expire_days')}
        </Title>
      </div>
      <div className='ml-21'>
        <Input
          type='number'
          value={val}
          placeholder=''
          onChange={handleInput}
          disabled={disabled || !isAdmin}
        />
        <Button
          className='mt-16 mb-16'
          type='fill'
          width='small'
          size={0}
          color='blue'
          onClick={submitVal}
          disabled={disabled || !isAdmin}
        >
          {translate(lang, 'Update')}
        </Button>
      </div>
    </div>
  );
};

export default LineAssessExpireDaysInput;
